export const siteSettings = {
  maintenanceMode: false,
  maintenanceVideoUrl: "/施工中.mov",
  supportUrl: "",
  feedbackEnabled: false,
  ratingEnabled: true
};

